import type { EntryPoint } from '@/apilib';
import { BaseResizeAndPushApiKey, EditorAPIKey } from '@/apis';
import { createBaseResizeAndPushApi } from './baseResizeAndPush';

export const BaseResizeAndPushEntrypoint: EntryPoint = {
  name: 'BaseResizeAndPush',
  declareAPIs: () => [BaseResizeAndPushApiKey],
  getDependencyAPIs: () => [EditorAPIKey],
  attach(shell) {
    shell.contributeAPI(BaseResizeAndPushApiKey, () =>
      createBaseResizeAndPushApi(shell),
    );
  },
};
